export default __webpack_public_path__ + "static/media/homep.b58b388d.png";